import type { ConsentLabels } from './types';

const ja: Required<ConsentLabels> = {
  eyebrow: 'PRIVACY CONTROL',
  bannerTitle: 'プライバシーの選択',
  bannerDescription: '当サイトでは、安全なサイト運営と外部コンテンツの表示のため、Cookieおよび外部サービスを目的ごとに利用します。用途を確認し、いつでも設定を変更できます。',
  acceptAll: 'すべて許可',
  rejectOptional: '必須のみ利用',
  openPreferences: '詳細を設定',
  preferencesTitle: 'プライバシー設定',
  preferencesDescription: '目的ごとに利用を選択できます。必須項目は、サイトを安全に提供するため常に有効です。',
  savePreferences: '選択内容を保存',
  close: '閉じる',
  required: '常に有効',
  optional: '任意',
  vendors: '利用サービス',
  dataItems: '送信される情報',
  purposes: '利用目的',
  removalInstructions: '停止・削除方法',
  privacyPolicy: 'プライバシーポリシー',
  gpcDetected: 'ブラウザのプライバシー信号を検出しました。広告・販売・共有目的の処理を停止しています。',
  saved: 'プライバシー設定を保存しました。フッターからいつでも変更できます。',
  saveFailed: '設定は更新しましたが、一部サービスの停止を確認できませんでした。ページを再読み込みしてください。',
  currentState: '現在の設定',
  acknowledge: '内容を確認しました',
};

const en: Required<ConsentLabels> = {
  eyebrow: 'PRIVACY CONTROL',
  bannerTitle: 'Your privacy choices',
  bannerDescription: 'We use cookies and external services by purpose to operate this site securely and display external content. You can review and change your choices at any time.',
  acceptAll: 'Accept all',
  rejectOptional: 'Necessary only',
  openPreferences: 'Manage choices',
  preferencesTitle: 'Privacy settings',
  preferencesDescription: 'Choose how each purpose may be used. Necessary items remain active to provide the site securely.',
  savePreferences: 'Save choices',
  close: 'Close',
  required: 'Always active',
  optional: 'Optional',
  vendors: 'Services',
  dataItems: 'Data sent',
  purposes: 'Purposes',
  removalInstructions: 'How to stop or remove',
  privacyPolicy: 'Privacy policy',
  gpcDetected: 'We detected your browser privacy signal. Advertising, sale and sharing purposes are disabled.',
  saved: 'Your privacy settings were saved. You can change them from the footer at any time.',
  saveFailed: 'Your choices were updated, but we could not confirm that every service stopped. Please reload the page.',
  currentState: 'Current setting',
  acknowledge: 'I understand',
};

export const getLabels = (locale: 'ja' | 'en' = 'ja', overrides: ConsentLabels = {}): Required<ConsentLabels> => ({
  ...(locale === 'en' ? en : ja),
  ...overrides,
});
